/* eslint-disable no-console */
import M from 'materialize-css/dist/js/materialize';
import * as actionLowering from '../actions/loweringAction';
import PickingService from './PickingService';
import { endLoading, startLoading } from '../actions/loadingAction';
import { ENUMS, PERMISSIONS, VISIONS } from '../utils/constants';
import { getUrlExpeditionApi, objPagination, parseParams, showMessageToastCustom, translate } from '../utils/util';
import HttpService from './HttpService';
import { checkPermission, getUser, getVision } from './auth';

const httpService = new HttpService(getUrlExpeditionApi(window));

export default class LoweringService {
    static firstOrder(filter, callback) {
        filter.excludeOrderGrouped = false;
        filter.status = [];
        const url = '/api/lowering/orders/first';

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, filter).then((response) => {
                    if (response.status === 200) {
                        if (response.data.data && response.data.data.orders) {
                            const dadosFilter = response.data.data;
                            if (dadosFilter?.orders?.length > 0) {
                                const dados = [dadosFilter]
                                const ordersPage = objPagination(dados[0].orders);
                                const orderSelect = dados[0].orders.filter((m) => (m.status === ENUMS.eOrderStatus.Waiting.value || m.status === ENUMS.eOrderStatus.InProgress.value)
                                    && m.items?.filter((j) => j.status === ENUMS.eOrderItemStatus.WaitingRepicking.value).length <= 0);

                                dispatch(actionLowering.resetOrder());
                                dispatch(actionLowering.resetOrders());
                                dispatch(actionLowering.resetOrderGroup());
                                dispatch(actionLowering.selectOrderGroup(dados[0]));
                                dispatch(actionLowering.setOrders(ordersPage));
                                dispatch(actionLowering.selectOrder(orderSelect[0]));
                                if (callback) {
                                    callback(orderSelect[0]);
                                }
                            }
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static startOrder(orderId, callback) {
        const url = `/api/picking/orders/${orderId}/start`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLowering.updateOrderStatus(orderId, ENUMS.eOrderStatus.InProgress.value));
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                dispatch(endLoading());
            }
        };
    }

    static startOrderItem(orderId, orderItemId, callback) {
        const url = '/api/picking/mission/start';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, orderItemId }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLowering.updateMissionStatus(orderItemId, ENUMS.eOrderItemStatus.InProgress.value));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    console.log('error on start orderItem', error);
                    if (callback) callback();
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static confirmPicking(orderItem, callback) {
        const url = '/api/picking';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, {
                    orderId: orderItem.orderId,
                    orderItemId: orderItem.orderItemId,
                    confirmMasterCim: orderItem.confirmMasterCim
                }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLowering.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.WaitingFinish.value));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            } else {
                showMessageToastCustom(translate('warning', 'general'), "Sem Conexão", 8000, 'mdi mdi-alert-circle-outline red-text');
            }
        };
    }

    static getOrders(filter, pagination, callback) {
        Object.assign(filter, pagination);
        const url = '/api/picking/orders';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        dispatch(actionLowering.setOrders(dados));
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getOrdersReport(filter, pagination, callback) {
        Object.assign(filter, pagination);
        const url = '/api/picking/report';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    }
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static rePicking(orderItem, areas, callback) {
        const url = '/api/picking/repicking';
        const dataSend = {
            orderId: orderItem.orderId,
            orderItemId: orderItem.orderItemId,
            justificationId: orderItem.justificationId,
            areas
        }

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, dataSend).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLowering.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.WaitingRepicking.value));
                        const newOrder = response.data?.newOrder;
                        if (newOrder && newOrder.orderId !== 0) {
                            dispatch(actionLowering.addOrder(newOrder));
                        }
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static unblockOrder(orderId, callback) {
        const url = `/api/picking/orders/${orderId}/unblock`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLowering.unblockOrder(orderId));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data?.message || "Erro", classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static userHasGroup(user) {
        const url = `/api/lowering/userhasgroup?user=${user}`;
        if (navigator.onLine) {
            httpService.instance.get(url).then((response) => {
                if (response.status === 200) {
                    return response.data.data;
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            });
        }
    }

    static abandonTask(orderId, callback) {
        const url = `/api/lowering/orders/abandontask/${orderId}`;
        if (navigator.onLine) {
            httpService.instance.put(url).then((response) => {
                if (response.status === 200) {
                    if (callback) {
                        callback()
                    }
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            });
        }
    }

    static updateOrderFromServer(order, changeUser) {
        return (dispatch) => {
            try {
                if (order) {
                    const manageOrder = checkPermission(PERMISSIONS.Expedition.Picking.ManageOrder);
                    const currentUser = getUser();
                    if ((!manageOrder && order.startedBy !== currentUser.userName)
                        || (order.status === ENUMS.eOrderStatus.Finished.value
                            || order.status === ENUMS.eOrderStatus.Canceled.value
                            || order.status === ENUMS.eOrderStatus.ManuallyFinished.value)) {
                    } else {
                        if (order.startedBy && order.startedBy.includes(currentUser.userName) && changeUser) {
                            if (VISIONS.Fiasa === getVision()) {
                                dispatch(actionLowering.updateOrder(order));
                                dispatch(actionLowering.selectOrder(order));
                                dispatch(PickingService.getMissions(order.orderId));
                                const url = `/api/lowering/userhasgroup?user=${currentUser.userName}`;
                                if (navigator.onLine) {
                                    httpService.instance.get(url).then((response) => {
                                        if (response.status === 200) {
                                            dispatch(actionLowering.setOrderReceived({
                                                order: order,
                                                showModalReceivedOrder: true,
                                                noHasGroup: response.data.data <= 0 ? true : false
                                            }));
                                        }
                                    }).catch((error) => {
                                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                                    });
                                }
                            } else {
                                showMessageToastCustom(translate('warning', 'general'), "Atenção! Nova tarefa atribuída a você.", 18000, 'mdi mdi-message-bulleted blue-text');
                            }
                        }
                    }
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static leave(orderGroupId, abandon, callback) {
        const url = `/api/lowering/ordergroup/leave`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderGroupId: orderGroupId, leave: abandon }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        }
    }

    static changeUserOrder(orderId, newUser, changeGroup, callback) {
        const url = '/api/lowering/orders/changeuser';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, newUser, changeGroup }).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLowering.changeUserOrder(orderId, newUser));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data?.message || "Erro", classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static changeRouteOrder(orderId, routeId, callback) {
        const url = '/api/lowering/orders/changeroute';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, routeId }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data?.message || "Erro", classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static cancelOrderFromServer(order) {
        return (dispatch) => {
            try {
                if (order) {
                    dispatch(actionLowering.removeOrder(order));
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static addOrderFromServer(order) {
        return (dispatch) => {
            try {
                if (order) {
                    dispatch(actionLowering.addOrder(order));
                }
            } catch (error) {
                console.log('erro: ', error);
            }
        };
    }

    static getNextOrder(filter, callback) {
        const url = '/api/lowering/orders/next';
        filter.nextOrder = true;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.post(url, filter).then((response) => {
                    if (response.status === 200 && response?.data?.data) {
                        let dados = response.data.data;
                        dispatch(actionLowering.addOrder(dados));
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message || 'Nenhum pedido encontrado!', 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                    if (callback) {
                        callback(response);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    if (callback) {
                        callback(error.response || error);
                    }
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static finishOrderGroup(filter, callback) {
        const url = '/api/lowering/orderGroup/finish';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderGroupId: filter.orderGroupId, finalQrCode: filter.finalQrCode }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }


    static unblock(orderId, changeGroup, callback) {
        const url = '/api/lowering/orders/unblock';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, { orderId, changeGroup }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data?.message || "Erro", classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getOrderGroupUser(callback) {
        const url = '/api/lowering/ordergroup';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback && response.data?.data) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static materialNotFound(orderItem, callback) {
        const url = '/api/lowering/materialnotfound';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url,
                    {
                        partial: orderItem.partial,
                        orderId: orderItem.orderId,
                        orderItemId: orderItem.orderItemId,
                        justificationId: orderItem.justificationId,
                        routeId: orderItem.routeId
                    }).then((response) => {
                        if (response.status === 200) {
                            dispatch(actionLowering.updateMissionStatus(orderItem.orderItemId, ENUMS.eOrderItemStatus.NotFound.value));
                            dispatch(actionLowering.updateOrderStatus(orderItem.orderId, ENUMS.eOrderStatus.NotFound.value));
                            if (callback) {
                                callback();
                            }
                        } else {
                            M.toast({ html: response.data.message, classes: 'red' });
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static finishedmaterialNotFound(orderId, callback) {
        const url = `/api/lowering/finishedmaterialnt/${orderId}`;

        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url).then((response) => {
                    if (response.status === 200) {
                        dispatch(actionLowering.updateOrderStatus(orderId, ENUMS.eOrderStatus.NotFoundFinished.value));
                        if (callback) {
                            callback();
                        }
                    } else {
                        M.toast({ html: response.data.message, classes: 'red' });
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getTransmission(filter, report, callback) {
        const url = '/api/transmission';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { params: filter }, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (!report) {
                            dispatch(actionLowering.setTransmissionsList(response.data?.data));
                        }
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static forceTramission() {
        const url = '/api/transmission';
        return (dispatch) => {
            if (navigator.onLine) {
                //dispatch(startLoading());
                httpService.instance.patch(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status !== 200) {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    } else {
                        showMessageToastCustom(translate('general.info'), "Em processamento...", 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getKanban(callback) {
        const url = `/api/lowering/kanban`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getReport(filter, callback) {
        const url = '/api/picking/orders/report';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url,
                    {
                        params: filter,
                        paramsSerializer: {
                            serialize: (params) => parseParams(params)
                        },
                        responseType: "blob"
                    }).then((response) => {
                        if (response.status === 200) {
                            if (callback) {
                                callback(response.data);
                            }
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }).finally(() => {
                        dispatch(endLoading());
                    });
            }
        };
    }

    static getQueues(filter, callback) {
        const url = '/api/lowering/queuelist';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getRoutes(filter, callback) {
        const url = '/api/lowering/routelist';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(url, {
                    params: filter,
                    paramsSerializer: {
                        serialize: (params) => parseParams(params)
                    },
                }).then((response) => {
                    if (response.status === 200) {
                        const dados = response.data.data;
                        if (callback) {
                            callback(dados);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static setArea(area) {
        return (dispatch) => { dispatch(actionLowering.setArea(area)); };
    }

    static setSectors(sectors) {
        return (dispatch) => { dispatch(actionLowering.setSectors(sectors)); };
    }
}